(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSbnNewController", LebaniegoYearContactosSectorSbnNewController);

    LebaniegoYearContactosSectorSbnNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorSbn",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorSbnNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorSbn,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSbn = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSbn = Object.assign({}, vm.lebaniegoYearContactosSectorSbn);
            lebaniegoYearContactosSectorSbn.id = null;
            lebaniegoYearContactosSectorSbn.sector = "Sector bebidas nacionales";
            LebaniegoYearContactosSectorSbn.save(lebaniegoYearContactosSectorSbn, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-sbn", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();